import React from 'react';

import {SvgProps} from '../../helpers/type';

const GraphUp = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="46"
            height="47"
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect x="0.7125" y="1.31248" width="44.175" height="44.175" rx="9.42083" fill="#EDFCF2" fillOpacity="0.5" />
            <path
                d="M26.2831 15.7999L29.1838 18.7005L23.0025 24.8819L17.9358 19.8152L8.5498 29.2139L10.3358 30.9999L17.9358 23.3999L23.0025 28.4665L30.9825 20.4992L33.8831 23.3999V15.7999H26.2831Z"
                fill="#5D847F"
            />
            <rect
                x="0.7125"
                y="1.31248"
                width="44.175"
                height="44.175"
                rx="9.42083"
                stroke="#E8EDEC"
                strokeWidth="1.425"
            />
        </svg>
    );
};

export default GraphUp;
